import {
  CLOUDINARY_IMAGE_BASE_URL,
  IMAGE_VERSION,
} from "../../../Common/constants";
import useCloudinaryData from "../../../Common/hooks/useCloudinaryData";
import Media from "../../media";

const RaceThumbnail = ({ countryName }) => {
  const { configData, cloudinaryBase, envVersion, currentSeasonYear } =
    useCloudinaryData();

  const trackThumbnail = configData?.imagePaths?.trackThumbnailImg;

  const flagImagePath = trackThumbnail
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion)
    ?.replaceAll("<current_season_year>", currentSeasonYear)
    ?.replaceAll("<circuit_short_name>", countryName);

  return (
    <Media imgSrc={flagImagePath} imgAlt={countryName} />
    // <img
    //   src={flagImagePath}
    //   alt={countryName}
    //   onError={({ currentTarget }) => {
    //     currentTarget.onerror = null; // prevents looping
    //     currentTarget.src = `${CLOUDINARY_IMAGE_BASE_URL}common/fallback.svg?v=${IMAGE_VERSION}`;
    //   }}
    //   loading="lazy"
    // />
  );
};

export default RaceThumbnail;
